import * as React from 'react';

function SvgCloudFog2Fill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.5 3a5.001 5.001 0 014.905 4.027A3 3 0 0113 13h-1.5a.5.5 0 000-1H1.05a3.51 3.51 0 01-.713-1H9.5a.5.5 0 000-1H.035a3.53 3.53 0 010-1H7.5a.5.5 0 000-1H.337a3.5 3.5 0 013.57-1.977A5.001 5.001 0 018.5 3z' />
		</svg>
	);
}

export default SvgCloudFog2Fill;
